import { render, staticRenderFns } from "./badge.vue?vue&type=template&id=4f6aed70&scoped=true"
import script from "./badge.vue?vue&type=script&lang=js"
export * from "./badge.vue?vue&type=script&lang=js"
import style0 from "./badge.vue?vue&type=style&index=0&id=4f6aed70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6aed70",
  null
  
)

export default component.exports